export var routes = [
    { name: "home", route: '', redirect: 'landing' },
    {
        name: "request-details", title: 'Request Details', route: 'requests/:id', moduleId: 'secure/requests/request-details',
        //condition: 'this.securityService.hasRole("cmp.role.edit")'
        role: 'Edit'
    },
    {
        name: "requests", title: 'Requests', route: 'requests', nav: true, moduleId: 'secure/requests/requests',
        //condition: 'this.securityService.hasRole("cmp.role.edit")'
        role: 'Edit'
    },
    {
        name: "tasks", title: 'Tasks', route: 'tasks', nav: true, moduleId: 'secure/tasks-home',
        //condition: 'this.securityService.hasRole("cmp.role.edit")'
        role: 'Edit'
    },
    // {
    //     name: "test", title: 'TEST', route: 'test', nav: true, moduleId: 'secure/form-components/compose-email/compose-email',
    //     condition: 'this.securityService.user.userName == "joseph.gabriel@nucor.com"'
    // },
    {
        name: "task-details", title: 'Task Details', route: 'tasks/:id', nav: false, moduleId: 'secure/task-details',
        //condition: 'this.securityService.hasRole("cmp.role.edit")'
        role: 'Edit'
    },
    {
        name: "ticket", title: 'Ticket Details', route: 'ticket/:id', nav: false, moduleId: 'secure/external/ticket-page/ticket-page',
        role: 'View'
    },
    {
        name: "my-tickets", title: 'My Tickets', route: 'my-tickets', nav: true, moduleId: 'secure/external/my-tickets-page/index',
        condition: '!this.securityService.hasRole("Edit")',
        role: 'View'
    },
    { name: "landing", route: 'landing', nav: false, moduleId: 'secure/landing' },
    { name: "dashboard", title: 'Dashboard', route: 'dashboard', nav: true, moduleId: 'secure/dashboard' },
    {
        name: "executive-dashboard", title: 'Executive Dashboard', route: 'executive-dashboard', nav: true,
        moduleId: 'secure/executive-dashboard', role: 'executive'
    },
    {
        name: "executive-dashboard-details", title: 'Executive Dashboard Details', route: 'executive-dashboard-details', nav: false,
        moduleId: 'secure/executive-dashboard-details', role: 'executive'
    },
    {
        name: "divisions", title: 'Divisions', route: 'divisions', nav: true, moduleId: 'secure/divisions'
    },
    {
        name: "divisions-edit", title: 'Divisions', route: 'divisions/:id', nav: false, moduleId: 'secure/divisions'
    },
    {
        name: "carriers", title: 'Search Carriers', route: 'carriers', nav: true, moduleId: 'secure/carriers',
        role: 'cmp.search.advanced'
    },
    {
        name: "mill-search-carriers", title: 'Match Maker Search', route: 'mill-search-carriers', nav: true, moduleId: 'secure/mill-search-carriers',
        condition: 'true'
        //condition: '!this.securityService.hasRole("cmp.search.advanced")'
    },
    { name: 'register', title: 'Registration', route: 'register', nav: false, moduleId: 'public/register/index' },
    { name: "carrier-status-history", route: 'carrier/:carrierId/status-history', moduleId: 'secure/carrier-status-history' },
    { name: "carrier-documents", route: 'carrier-documents/:carrierId', moduleId: 'secure/carrier-documents', role: 'view' },
    { name: 'access-denied', route: 'access-denied', title: "Access Denied", nav: false, moduleId: 'secure/access-denied' },
    { name: 'not-found', route: 'not-found', moduleId: 'public/system/not-found/index' },
    {
        name: 'register-user', route: 'register-user', nav: false, moduleId: 'secure/register-user', role: 'admin'
    },

    { name: 'user-admin', route: 'user-admin', nav: false, moduleId: 'secure/user-admin', role: 'user_admin' },
    { name: 'alphabet-assignment', route: 'alphabet-assignment', nav: false, moduleId: 'secure/alphabet-assignment', role: 'user_admin' },
    { name: 'new-user-queue', route: 'new-user-queue', nav: false, moduleId: 'secure/new-user-queue', role: 'admin' },
    { name: "work-carrier", route: 'work-carrier/:carrierId', moduleId: 'secure/work-carrier' },
    { name: 'carrier-summary', route: 'carrier-summary/:carrierId', nav: false, moduleId: 'secure/carrier-summary' },
    { name: 'kiosk', route: 'kiosk', nav: false, moduleId: 'secure/kiosk' },
    { name: 'status-scoreboard', route: 'status-scoreboard', nav: false, moduleId: 'secure/status-scoreboard' },
    { name: 'emails', route: 'emails', nav: false, moduleId: 'secure/emails' },
    { name: 'email-viewer', route: 'emails/:emailId', nav: false, moduleId: 'secure/email-viewer' },
    { name: 'change-password', route: 'change-password', nav: false, moduleId: 'public/login/change-password' },
    { name: 'new-carrier-request', role: "request_roster_change", route: 'requests/new-carrier', nav: false, moduleId: 'secure/requests/new-carrier-request/new-carrier-request' },

];